import React from "react";
import pdf from "assets/img/pdf_icon.svg";
import ImgContainer from "components/common/img";
import { Progress } from "reactstrap";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

const UploadPreviewDetailsLeft = styled.div`
  overflow: hidden;

  .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 0;
  }
`;

const UploadPreviewProgress = styled.div`
  margin-top: 0.5rem;
`;

const UploadPreviewProgressSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const UploadPreviewIconSection = styled.div`
  margin-right: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadPreviewDetailsRight = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const UploadPreviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
`;

const UploadPreviewFileDetails = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr 40px;
`;

const StyledImgContainer = styled(ImgContainer)`
  height: 45px;
`;

const FileSizeText = styled.span`
  margin: 0;
`;

const SuccessUploadIcon = styled(FontAwesomeIcon)`
  color: #0ebf80;
  margin-right: 0.5rem;
`;

const DeleteIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
`;

const FilePreview = ({
  name,
  size,
  percent,
  handleDeleteFile,
  isDisabled = false,
  fileDownload,
  fileUrl = null,
}) => {
  return (
    <UploadPreviewContainer>
      <UploadPreviewIconSection>
        <StyledImgContainer src={pdf} />
      </UploadPreviewIconSection>

      <UploadPreviewProgressSection>
        <UploadPreviewFileDetails>
          <UploadPreviewDetailsLeft>
            {/* eslint-disable 
              jsx-a11y/click-events-have-key-events */}
            <span
              role="button"
              tabIndex="-1"
              onClick={() => fileDownload(fileUrl)}
              className="file-name"
            >
              {name}
            </span>
            {size ? <FileSizeText>{`${size} Kb`}</FileSizeText> : null}
          </UploadPreviewDetailsLeft>

          <UploadPreviewDetailsRight>
            {percent === 100 ? (
              <SuccessUploadIcon icon={faCircleCheck} />
            ) : null}

            {!isDisabled ? (
              <a
                href="!#"
                disabled={isDisabled}
                onClick={(e) => {
                  e.preventDefault();
                  handleDeleteFile(name);
                }}
              >
                <DeleteIcon
                  icon={faTrash}
                  onClick={() => {
                    handleDeleteFile(name);
                  }}
                />
              </a>
            ) : null}
          </UploadPreviewDetailsRight>
        </UploadPreviewFileDetails>

        <UploadPreviewProgress>
          <Progress value={percent || 0} />
        </UploadPreviewProgress>
      </UploadPreviewProgressSection>
    </UploadPreviewContainer>
  );
};

FilePreview.prototype = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  percent: PropTypes.number.isRequired,
  handleDeleteFile: PropTypes.func.isRequired,
};

export default React.memo(FilePreview);
